<template>
  <!-- 尺寸为300*150，可在这个范围内DIY -->
    <div class="div-container" @click="jump">
      <div class="div-box">
        <span>商务服务业发展地图</span>
      </div>
    </div>
</template>

<script>
    export default {
      name: "MemberCard",
      methods: {
          jump () {
            window.parent.location.href = '/web/industry-analyze/#/ent/list'
          }
      }
    }
</script>

<style scoped>
.div-container {
  width: 300px;
  height: 150px;
  background-color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
